import React, { Component } from 'react'
import ToolTip from '../../ToolTip'
import css from './styles.scss'

export class CheckBox extends Component {
  constructor ({ checked, schema }) {
    super()
    this.state = {
      checked: checked || false
    }
  }

  handleUpdateCheck = evt => {
    this.setState({
      checked: evt.target.checked
    }, () => this.save())
  }

  save = () => {
    this.props.save(this.props.dataKey, this.state.checked, this.props.idx)
  }

  render () {
    const { checked } = this.state
    const { schema } = this.props
    return (
      <div className={css.CheckBox}>
        <label className={css.label}>
          <input onChange={this.handleUpdateCheck} checked={checked} type='checkbox' /> {schema.label} <ToolTip tips={schema.description} />
        </label>
        <p className={css.schemas}>
          {schema.templates.join(', ')}
        </p>
      </div>
    )
  }
}

export default CheckBox



// WEBPACK FOOTER //
// /app/js/components/EditorGUI/CheckBox/index.js